module.exports = __webpack_public_path__ + "static/media/advice-bg.270bf8f4.png";